import { Injectable } from '@angular/core';

import { AxiosService } from './../../../core/axios';

import { UserSendCodeDTO, UserDTO, UserLoginDTO } from './../../dto/user.dto';
import { WorkShopDTO } from './../../dto/work-shop.dto';
import { CountryCmbDto } from './../../dto/country.dto';
import { StateDto, CityDto } from './../../dto/city.dto';
import { ResponseCodeDTO } from './../../../shared/dto/response-codes.dto';

@Injectable({
  providedIn: 'root',
})
export class CommonService {
  constructor(private readonly axiosService: AxiosService) {
    // do nothing
  }

  async getAvailableServiceCenters(): Promise<WorkShopDTO[]> {
    const result: ResponseCodeDTO = await this.axiosService.get('/service-center');
    return result.code.code === 'PTZ0000' ? result.data : [];
  }

  async getAvailableCountriesToCmb(): Promise<CountryCmbDto[]> {
    const result: ResponseCodeDTO = await this.axiosService.get('/utilities/findAvailableCountriesToCmb');
    return result.code.code === 'PTZ0000' ? result.data : [];
  }

  async getAvailableStatesByCountryCode(countryCoed: string): Promise<StateDto[]> {
    const result: ResponseCodeDTO = await this.axiosService.get(`/utilities/findAvailableStatesByCountryCode?ctyCde=${countryCoed}`);
    return result.code.code === 'PTZ0000' ? result.data : [];
  }

  async getAvailableCityByStateCountryCode(countryCoed: string, stateCode: string): Promise<CityDto[]> {
    const result: ResponseCodeDTO = await this.axiosService.get(`/utilities/findAvailableCityByStateCountryCode?ctyCde=${countryCoed}&steCde=${stateCode}`);
    console.log('getAvailableCityByStateCountryCode', result);
    return result.code.code === 'PTZ0000' ? result.data : [];
  }

  async getIPAddress(): Promise<string> {
    try {
      return new Promise((resolve) => {
        fetch('https://api.ipify.org?format=json')
          .then((response) => response.json())
          .then((data) => {
            resolve(data.ip);
          })
          .catch((error) => {
            console.log('EXCEPTION | getIPAddress - reject - ', error);
            resolve('');
          });
      });
    } catch (error: any) {
      console.error('EXCEPTION | getIPAddress - ', error);
      return '';
    }
  }

  async sendSmsCode(user: UserSendCodeDTO): Promise<ResponseCodeDTO> {
    return await this.axiosService.post('/auth/sendCodeValidate', { data: user });
  }

  async validateSmsCode(user: UserSendCodeDTO): Promise<ResponseCodeDTO> {
    return await this.axiosService.post('/auth/codeValidate', { data: user });
  }

  async registerUser(user: UserDTO): Promise<ResponseCodeDTO> {
    return await this.axiosService.post('/auth/register', { data: user });
  }

  async login(user: UserLoginDTO): Promise<ResponseCodeDTO> {
    return await this.axiosService.post('/auth/login', { data: user });
  }
}
